<template>
  <div class="atividades-rfilancamentos ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <!-- -->
        <b-col cols="3">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="3">
          <label for="select-filial-lin">Filial</label>
          <multiselect
            id="selecao-filial-lin"
            v-model="value_filial"
            required
            :options="filiais"
            :multiple="true"
            :taggable="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="1">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            :disabled="carregando"
            @click="loadLinhas()"
          >
            <b-spinner v-if="carregando" small style="margin-bottom: 3px">
            </b-spinner>
            Pesquisar
          </b-button>
        </b-col>

        <b-col cols="1">
          <br />
          <b-button
            variant="warning"
            class="ml-5 mt-2"
            v-b-modal.modal-multi-2
            @click="reset(), getPontoTp(), getPontoTs()"
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      id="linhalancamentos"
      small
      hover
      striped
      sticky-header="550px"
      :items="linhas"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @mouseup="loadEditLinha(data.item)"
          @click="
            (cadastroLinha = !cadastroLinha),
              loadLinhas(),
              getpontp(),
              getponts()
          "
          title="Editar linha"
          size="sm"
          variant="success"
          class="mr-2"
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
    <div>
      <b-modal
        id="modal-multi-2"
        v-model="cadastroLinha"
        cancel-title="Fechar"
        ok-title="Gravar"
        @ok="postLinha(), loadLinhas()"
        @cancel="(cadastroLinha = !cadastroLinha), reset()"
        hide-footer
        size="xl"
        title="Cadastro de Linhas"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- -->
        <div>
          <b-row>
            <b-col cols="6">
              <label for="input-filial">Filial</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="lin.id_filial"
                  required
                  :options="filiais"
                  class="mb-3"
                  text-field="filial"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2" class="mb-2">
              <label for="input-live">Nro da linha</label>
              <b-form-input
                v-model="lin.linha"
                required
                placeholder="Nro linha"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-linha">Lote</label>
              <div>
                <b-form-select
                  id="lote"
                  v-model="lin.id_lote"
                  required
                  :options="lote"
                  class="mb-3"
                  text-field="lote"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2" class="mb-2">
              <label for="input-live">ID LINHA ERP</label>
              <b-form-input
                v-model="lin.id_linha_erp"
                required
                placeholder="id_linha_erp"
              ></b-form-input>
            </b-col>

            <b-col cols="6" class="mb-2">
              <label for="input-live">Descrição da linha</label>
              <b-form-input
                v-model="lin.denominacao"
                required
                placeholder="Digite a denominação da linha"
              ></b-form-input>
            </b-col>

            <b-col cols="3">
              <label for="input-setor">Tipo da linha</label>
              <div>
                <b-form-select
                  v-model="lin.id_tipo"
                  required
                  :options="tipo"
                  class="mb-3"
                  text-field="tipo"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="3">
              <label for="input-status">Status</label>
              <div>
                <b-form-select
                  v-model="lin.id_status"
                  required
                  :options="status"
                  class="mb-3"
                  text-field="status"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="6">
              <label for="input-tp">Terminal Principal</label>
              <!--tp {{fptp.map(tp => tp.id_ponlin)}}-->
              <div>
                <b-form-select
                  v-model="lin.id_ponto_tp"
                  required
                  :options="pontotp"
                  class="mb-3"
                  text-field="ponto"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="6">
              <label for="input-ts">Terminal Secundário</label>
              <!-- ts {{fpts.map(ts => ts.id_ponlin)}} -->
              <div>
                <b-form-select
                  id="ts"
                  v-model="lin.id_ponto_ts"
                  required
                  :options="pontots"
                  class="mb-3"
                  text-field="ponto"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2">
              <label for="input-live">KM - G -> TP</label>
              <b-form-input
                id="gar_tp"
                v-model="lin.gar_tp"
                required
                placeholder="Ex.: 22,00"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">KM - G -> TS</label>
              <b-form-input
                id="gar_ts"
                v-model="lin.gar_ts"
                required
                placeholder="Ex.: 1,2"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">KM - TP -> TS</label>
              <b-form-input
                id="tp_ts"
                v-model="lin.tp_ts"
                required
                placeholder="Ex.: 26,00"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">KM - TS -> TP</label>
              <b-form-input
                id="ts_tp"
                v-model="lin.ts_tp"
                required
                placeholder="Ex.: 25,50"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">KM - TP -> G</label>
              <b-form-input
                id="tp_gar"
                v-model="lin.tp_gar"
                required
                placeholder="Ex.: 1,1"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">KM - TS -> G</label>
              <b-form-input
                id="ts_gar"
                v-model="lin.ts_gar"
                required
                placeholder="Ex.: 1,4"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="4">
              <label for="input-live">Frota uteis</label>
              <b-form-input
                id="frota_uteis"
                v-model="lin.frota_uteis"
                required
                placeholder="Ex.: 26"
              >
              </b-form-input>
            </b-col>

            <b-col cols="4">
              <label for="input-live">Frota sabado</label>
              <b-form-input
                id="frota_sabado"
                required
                v-model="lin.frota_sabado"
                placeholder="Ex.: 22"
              ></b-form-input>
            </b-col>

            <b-col cols="4">
              <label for="input-live">Frota domingo</label>
              <b-form-input
                id="frota_domingo"
                required
                v-model="lin.frota_domingo"
                placeholder="Ex.: 18"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-2 mb-2">
            <b-col cols="6">
              <label for="input-live"
                >Atraso em minutos - justificar partida</label
              >
              <b-form-input
                v-model="lin.atraso_minutos"
                required
                placeholder="tempo limite para não justificar atraso na partida"
              ></b-form-input>
            </b-col>

            <b-col cols="6" class="mb-6">
              <label for="input-live"
                >Antecedência em minutos - batida de ponto</label
              >
              <b-form-input
                v-model="lin.antecedencia_registrar_ponto"
                required
                placeholder="tempo limite para registrar ponto"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-button
            class="mt-3"
            variant="success"
            block
            @click="postLinha(), reset()"
            >Gravar</b-button
          >
          <!--   postTp(),  postTs(),  -->
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapState } from "vuex";

export default {
  computed: { ...mapState(["user"]) },

  name: "PlanejamentoLinha",

  data: function () {
    return {
      mode: "save",
      carregando: false,
      atualizando: false,

      empresa: {},
      empresas: [], // [] lista
      filial: {},
      filiais: [], // [] lista

      garagem: {},
      garagens: [], // [] lista
      lin: {},
      linhas: {},
      lote: [],
      tipo: [],
      pontotp: [],
      pontots: [],
      fptp: [], // pegar valor para ser usando no app para filtrar as linhas do ponto independente do sentido.
      fpts: [], // pegar valor para ser usando no app para filtrar as linhas do ponto independente do sentido.
      value_filial: [],
      filial: [],
      filiais: [],

      status: [],

      selected: null,
      //  barra_inicial: 0,
      //  barra_limite: 300000,

      fields: [
        { key: "id_linha", label: "ID", sortable: true },
        { key: "id_filial", label: "Garagem", sortable: true },
        { key: "linha", label: "Nro Linha", sortable: true },

        { key: "lote", label: "Lote", sortable: true },
        { key: "denominacao", label: "Denominação", sortable: true },

        { key: "tp", label: "TP", sortable: true },
        { key: "ts", label: "TS", sortable: true },

        { key: "frota_uteis", label: " Frota Uteis", sortable: true },
        //{ key: 'frota_sabado', label: ' Frota Sab', sortable: true },
        //{ key: 'frota_domingo', label: ' Frota Dom', sortable: true },

        { key: "atraso_minutos", label: "Min Atraso", sortable: true },
        {
          key: "antecedencia_registrar_ponto",
          label: "Min Antecedencia",
          sortable: true,
        },

        // { key: 'cadastrado_por', label: 'Cadastrado por', sortable: true },
        { key: "status", label: "Status", sortable: true },

        {
          key: "dt_cadastro",
          label: "Data Cadastro",
          sortable: true,
          formatter: (value, key, linhas) => {
            return moment(linhas.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },

        {
          key: "dt_atualizacao",
          label: "Data alteração",
          sortable: true,
          formatter: (value, key, linhas) => {
            return moment(linhas.dt_atualizacao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },

        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {
    Multiselect,
  },

  methods: {
    //barra de progresso
    ready() {
      this.handle = setInterval(() => {
        this.barra_inicial = this.barra_inicial + 1000;
        if (this.barra_inicial >= this.barra_limite) {
          this.barra_inicial = 0;
          //this.loadRfiLancamentos()
        }
      }, 1000);
    },

    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    loadEmpresa() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.filiais = res.data.map((fil) => {
            return { ...fil, value: fil.id_filial_erp, filial: fil.filial }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    async loadLote() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/linha/lote`;
      return await axios.get(url, { params }).then((res) => {
        this.lote = res.data.map((lot) => {
          return { ...lot, value: lot.id_lote, lote: lot.lote };
        });
      });
    },

    async loadLinhaTipo() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/linha/tipo`;
      return await axios.get(url, { params }).then((res) => {
        this.tipo = res.data.map((tipo) => {
          return { ...tipo, value: tipo.id_tipo, tipo: tipo.tipo };
        });
      });
    },

    async loadLinhaStatus() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/linha/status`;
      return await axios.get(url, { params }).then((res) => {
        this.status = res.data.map((status) => {
          return { ...status, value: status.id_status, status: status.status };
        });
      });
    },

    async loadTerminalTp() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/pontocad`;
      return await axios.get(url, { params }).then((res) => {
        this.tp = res.data.map((tp) => {
          return { ...tp, value: tp.id_ponto, ponto: tp.ponto };
        });
      });
    },

    async loadTerminalTs() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/pontocad`;
      return await axios.get(url, { params }).then((res) => {
        this.ts = res.data.map((ts) => {
          return { ...ts, value: ts.id_ponto, ponto: ts.ponto };
        });
      });
    },

    loadLinhas() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${[this.value_filial.map((fi) => fi.value)]}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/planejamento/linha/cad`;
      return axios.get(url, { params }).then((res) => {
        this.linhas = res.data.map((linha) => {
          return { ...linha };
        });
      });
    },

    postLinha() {
      let corpo = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.lin.id_filial}`,
        id_linha: `${this.lin.id_linha}`,
        id_linha_erp: `${this.lin.id_linha_erp}`,
        linha: `${this.lin.linha}`,
        denominacao: `${this.lin.denominacao}`,
        id_tipo: `${this.lin.id_tipo}`,
        id_lote: `${this.lin.id_lote}`,
        id_status: `${this.lin.id_status}`,
        id_ponto_tp: `${this.lin.id_ponto_tp}`,
        id_ponto_ts: `${this.lin.id_ponto_ts}`,
        gar_tp: `${this.lin.gar_tp}`,
        gar_ts: `${this.lin.gar_ts}`,
        tp_ts: `${this.lin.tp_ts}`,
        ts_tp: `${this.lin.ts_tp}`,
        tp_gar: `${this.lin.tp_gar}`,
        ts_gar: `${this.lin.ts_gar}`,
        frota_uteis: `${this.lin.frota_uteis}`,
        frota_sabado: `${this.lin.frota_sabado}`,
        frota_domingo: `${this.lin.frota_domingo}`,
        atraso_minutos: `${this.lin.atraso_minutos}`,
        antecedencia_registrar_ponto: `${this.lin.antecedencia_registrar_ponto}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/planejamento/linha`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess(), this.reset(); //limpar os objetos valores
          this.loadLinhas();
        })
        .catch(showError);
    },

    getPontoTp() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_linha: `${this.lin.id_linha}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/planejamento/ponto`;
      axios.get(url, { params }).then((res) => {
        this.pontotp = res.data.map((ptp) => {
          return { ...ptp, value: ptp.id_ponto, ponto: ptp.ponto };
        });
      });
    },

    getPontoTs() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_linha: `${this.lin.id_linha}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/planejamento/ponto`;
      axios.get(url, { params }).then((res) => {
        this.pontots = res.data.map((pts) => {
          return { ...pts, value: pts.id_ponto, ponto: pts.ponto };
        });
      });
    },

    // carrega o ID associado a linha e sentido que será utilizado para montar o filtro por terminal no app
    getpontp() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_linha: `${this.lin.id_linha}`,
        id_ponlintp: `${this.fptp.map((p) => p.id_ponlin)}`,
        id_sentido: 1,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/planejamento/linha/gcadtp`;
      axios.get(url, { params }).then((res) => {
        this.fptp = res.data.map((ptp) => {
          return { ...ptp, value: ptp.id_ponto, ponto: ptp.ponto };
        });
      });
    },

    // carrega o ID associado a linha e sentido que será utilizado para montar o filtro por terminal no app
    getponts() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_linha: `${this.lin.id_linha}`,
        id_ponlints: `${this.fpts.map((p) => p.id_ponlin)}`,
        id_sentido: 2,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/planejamento/linha/gcadts`;
      axios.get(url, { params }).then((res) => {
        this.fpts = res.data.map((pts) => {
          return { ...pts, value: pts.id_ponto, ponto: pts.ponto };
        });
      });
    },

    /////////////////////////////// cadastro tp associado a linha para filtrar o terminal no app
    postTp() {
      let corpo = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.lin.id_filial}`,
        id_linha: `${this.lin.id_linha}`,
        id_ponto_tp: `${this.lin.id_ponto_tp}`,
        id_ponlintp: `${this.fptp.map((tp) => tp.id_ponlin)}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/planejamento/linha/cadtp`;
      axios
        .post(url, corpo)
        .then(() => {})
        .catch(showError);
    },

    /////////////////////////////// cadastro tp
    postTs() {
      let corpo = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.lin.id_filial}`,
        id_linha: `${this.lin.id_linha}`,
        id_ponto_ts: `${this.lin.id_ponto_ts}`,
        id_ponlints: `${this.fpts.map((ts) => ts.id_ponlin)}`,
      };

      const url = `${baseApiUrl}/planejamento/linha/cadts`;
      axios
        .post(url, corpo)
        .then(() => {
          //this.$toasted.global.defaultSuccess()
        })
        .catch(showError);
    },

    loadEditLinha(lin) {
      this.lin = { ...lin };
    },

    reset() {
      //this.lin = {}
      //this.lin = []
      this.loadLinhas();
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadFiliais();
    this.loadLote();
    this.loadLinhaTipo();
    this.loadLinhaStatus();
    this.getPontoTp();
    this.getPontoTs();
    this.loadLinhas();
    this.loadEditLinha();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.7em;
}

#rfilancamentos {
  font-size: 0.9em;
  text-align: center;
}
</style>